import * as import1 from './snippets/mls-rs-core-77e30828bc5a77d3/inline0.js';

/* @ts-self-types="./index.d.ts" */

export class RustCallStatus {
  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    RustCallStatusFinalization.unregister(this);
    return ptr;
  }
  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_rustcallstatus_free(ptr, 0);
  }
  /**
   * @returns {number}
   */
  get code() {
    const ret = wasm.__wbg_get_rustcallstatus_code(this.__wbg_ptr);
    return ret;
  }
  /**
   * @returns {Uint8Array | undefined}
   */
  get errorBuf() {
    const ptr = this.__destroy_into_raw();
    const ret = wasm.rustcallstatus_error_buf(ptr);
    let v1;
    if (ret[0] !== 0) {
      v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
      wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
    }
    return v1;
  }
  constructor() {
    const ret = wasm.rustcallstatus_new();
    this.__wbg_ptr = ret >>> 0;
    RustCallStatusFinalization.register(this, this.__wbg_ptr, this);
    return this;
  }
  /**
   * @param {Uint8Array | null} [bytes]
   */
  set errorBuf(bytes) {
    var ptr0 = isLikeNone(bytes) ? 0 : passArray8ToWasm0(bytes, wasm.__wbindgen_malloc);
    var len0 = WASM_VECTOR_LEN;
    wasm.rustcallstatus_set_error_buf(this.__wbg_ptr, ptr0, len0);
  }
  /**
   * @param {number} arg0
   */
  set code(arg0) {
    wasm.__wbg_set_rustcallstatus_code(this.__wbg_ptr, arg0);
  }
}
if (Symbol.dispose) RustCallStatus.prototype[Symbol.dispose] = RustCallStatus.prototype.free;

/**
 * @returns {number}
 */
export function ubrn_ffi_mls_rs_uniffi_uniffi_contract_version() {
  const ret = wasm.ubrn_ffi_mls_rs_uniffi_uniffi_contract_version();
  return ret >>> 0;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_constructor_client_new() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_constructor_client_new();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_func_client_config_default() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_func_client_config_default();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_func_generate_signature_keypair() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_func_generate_signature_keypair();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_func_message_from_bytes() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_func_message_from_bytes();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_func_message_to_bytes() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_func_message_to_bytes();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_client_create_group() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_client_create_group();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_client_generate_key_package_message() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_client_generate_key_package_message();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_client_join_group() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_client_join_group();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_client_load_group() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_client_load_group();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_client_signing_identity() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_client_signing_identity();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_member() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_member();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_members() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_add_members();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_build() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_build();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_member() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_member();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_members() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_commitbuilder_remove_members();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_add_members() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_add_members();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_clear_pending_commit() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_clear_pending_commit();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_commit() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_commit();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_commit_builder() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_commit_builder();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_current_epoch() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_current_epoch();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_encrypt_application_message() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_encrypt_application_message();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_export_tree() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_export_tree();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_group_id() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_group_id();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_members() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_members();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_process_incoming_message() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_process_incoming_message();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_propose_add_members() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_propose_add_members();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_propose_remove_members() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_propose_remove_members();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_remove_members() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_remove_members();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_group_write_to_storage() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_group_write_to_storage();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_epoch() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_epoch();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_max_epoch_id() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_max_epoch_id();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_state() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_state();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_write() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_groupstatestorage_write();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_delete() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_delete();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_get() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_get();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_insert() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_keypackagestorage_insert();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_message_epoch() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_message_epoch();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_message_key_package_reference() {
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_message_key_package_reference();
  return ret;
}

/**
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_checksum_method_message_welcome_key_package_references() {
  const ret =
    wasm.ubrn_uniffi_mls_rs_uniffi_checksum_method_message_welcome_key_package_references();
  return ret;
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_client(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_client(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_commitbuilder(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_commitbuilder(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_extension(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_extension(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_extensionlist(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_extensionlist(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_group(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_group(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_groupstatestorage(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_groupstatestorage(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_keypackagestorage(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_keypackagestorage(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_message(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_message(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_proposal(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_proposal(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_clone_signingidentity(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_clone_signingidentity(ptr, f_status_.__wbg_ptr);
  return BigInt.asUintN(64, ret);
}

/**
 * @param {Uint8Array} id
 * @param {Uint8Array} signature_keypair
 * @param {Uint8Array} client_config
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_constructor_client_new(
  id,
  signature_keypair,
  client_config,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  const ptr1 = passArray8ToWasm0(signature_keypair, wasm.__wbindgen_malloc);
  const len1 = WASM_VECTOR_LEN;
  const ptr2 = passArray8ToWasm0(client_config, wasm.__wbindgen_malloc);
  const len2 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_constructor_client_new(
    ptr0,
    len0,
    ptr1,
    len1,
    ptr2,
    len2,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_client(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_client(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_commitbuilder(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_commitbuilder(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_extension(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_extension(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_extensionlist(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_extensionlist(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_group(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_group(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_groupstatestorage(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_groupstatestorage(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_keypackagestorage(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_keypackagestorage(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_message(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_message(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_proposal(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_proposal(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_free_signingidentity(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_free_signingidentity(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_func_client_config_default(f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_func_client_config_default(f_status_.__wbg_ptr);
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {Uint8Array} cipher_suite
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_func_generate_signature_keypair(
  cipher_suite,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(cipher_suite, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_func_generate_signature_keypair(
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {Uint8Array} data
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_func_message_from_bytes(data, f_status_) {
  const ptr0 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_func_message_from_bytes(
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} msg
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_func_message_to_bytes(msg, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_func_message_to_bytes(msg, f_status_.__wbg_ptr);
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {any} vtable
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_init_callback_vtable_groupstatestorage(vtable) {
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_init_callback_vtable_groupstatestorage(vtable);
}

/**
 * @param {any} vtable
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_init_callback_vtable_keypackagestorage(vtable) {
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_init_callback_vtable_keypackagestorage(vtable);
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} group_id
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_client_create_group(ptr, group_id, f_status_) {
  const ptr0 = passArray8ToWasm0(group_id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_client_create_group(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_client_generate_key_package_message(
  ptr,
  f_status_
) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_client_generate_key_package_message(
    ptr,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} ratchet_tree
 * @param {bigint} welcome_message
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_client_join_group(
  ptr,
  ratchet_tree,
  welcome_message,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(ratchet_tree, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_client_join_group(
    ptr,
    ptr0,
    len0,
    welcome_message,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} group_id
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_client_load_group(ptr, group_id, f_status_) {
  const ptr0 = passArray8ToWasm0(group_id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_client_load_group(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_client_signing_identity(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_client_signing_identity(
    ptr,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {bigint} key_package
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_add_member(
  ptr,
  key_package,
  f_status_
) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_add_member(
    ptr,
    key_package,
    f_status_.__wbg_ptr
  );
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} key_packages
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_add_members(
  ptr,
  key_packages,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(key_packages, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_add_members(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_build(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_build(
    ptr,
    f_status_.__wbg_ptr
  );
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {bigint} signing_identity
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_remove_member(
  ptr,
  signing_identity,
  f_status_
) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_remove_member(
    ptr,
    signing_identity,
    f_status_.__wbg_ptr
  );
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} signing_identities
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_remove_members(
  ptr,
  signing_identities,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(signing_identities, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_commitbuilder_remove_members(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} key_packages
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_add_members(
  ptr,
  key_packages,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(key_packages, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_add_members(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_clear_pending_commit(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_clear_pending_commit(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_commit(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_commit(ptr, f_status_.__wbg_ptr);
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_commit_builder(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_commit_builder(
    ptr,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_current_epoch(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_current_epoch(
    ptr,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} message
 * @param {RustCallStatus} f_status_
 * @returns {bigint}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_encrypt_application_message(
  ptr,
  message,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(message, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_encrypt_application_message(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  return BigInt.asUintN(64, ret);
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_export_tree(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_export_tree(ptr, f_status_.__wbg_ptr);
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_group_id(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_group_id(ptr, f_status_.__wbg_ptr);
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_members(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_members(ptr, f_status_.__wbg_ptr);
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {bigint} message
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_process_incoming_message(
  ptr,
  message,
  f_status_
) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_process_incoming_message(
    ptr,
    message,
    f_status_.__wbg_ptr
  );
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} key_packages
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_propose_add_members(
  ptr,
  key_packages,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(key_packages, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_propose_add_members(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} signing_identities
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_propose_remove_members(
  ptr,
  signing_identities,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(signing_identities, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_propose_remove_members(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} signing_identities
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_remove_members(
  ptr,
  signing_identities,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(signing_identities, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_remove_members(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_group_write_to_storage(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_group_write_to_storage(ptr, f_status_.__wbg_ptr);
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} group_id
 * @param {bigint} epoch_id
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_epoch(
  ptr,
  group_id,
  epoch_id,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(group_id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_epoch(
    ptr,
    ptr0,
    len0,
    epoch_id,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} group_id
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_max_epoch_id(
  ptr,
  group_id,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(group_id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_max_epoch_id(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} group_id
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_state(
  ptr,
  group_id,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(group_id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_state(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} group_id
 * @param {Uint8Array} group_state
 * @param {Uint8Array} epoch_inserts
 * @param {Uint8Array} epoch_updates
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_write(
  ptr,
  group_id,
  group_state,
  epoch_inserts,
  epoch_updates,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(group_id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  const ptr1 = passArray8ToWasm0(group_state, wasm.__wbindgen_malloc);
  const len1 = WASM_VECTOR_LEN;
  const ptr2 = passArray8ToWasm0(epoch_inserts, wasm.__wbindgen_malloc);
  const len2 = WASM_VECTOR_LEN;
  const ptr3 = passArray8ToWasm0(epoch_updates, wasm.__wbindgen_malloc);
  const len3 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_groupstatestorage_write(
    ptr,
    ptr0,
    len0,
    ptr1,
    len1,
    ptr2,
    len2,
    ptr3,
    len3,
    f_status_.__wbg_ptr
  );
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} id
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_delete(ptr, id, f_status_) {
  const ptr0 = passArray8ToWasm0(id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_delete(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} id
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_get(ptr, id, f_status_) {
  const ptr0 = passArray8ToWasm0(id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_get(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} id
 * @param {Uint8Array} data
 * @param {RustCallStatus} f_status_
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_insert(
  ptr,
  id,
  data,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(id, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  const ptr1 = passArray8ToWasm0(data, wasm.__wbindgen_malloc);
  const len1 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_keypackagestorage_insert(
    ptr,
    ptr0,
    len0,
    ptr1,
    len1,
    f_status_.__wbg_ptr
  );
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_message_epoch(ptr, f_status_) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_message_epoch(ptr, f_status_.__wbg_ptr);
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {Uint8Array} cipher_suite
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_message_key_package_reference(
  ptr,
  cipher_suite,
  f_status_
) {
  const ptr0 = passArray8ToWasm0(cipher_suite, wasm.__wbindgen_malloc);
  const len0 = WASM_VECTOR_LEN;
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_message_key_package_reference(
    ptr,
    ptr0,
    len0,
    f_status_.__wbg_ptr
  );
  var v2 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v2;
}

/**
 * @param {bigint} ptr
 * @param {RustCallStatus} f_status_
 * @returns {Uint8Array}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_message_welcome_key_package_references(
  ptr,
  f_status_
) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_message_welcome_key_package_references(
    ptr,
    f_status_.__wbg_ptr
  );
  var v1 = getArrayU8FromWasm0(ret[0], ret[1]).slice();
  wasm.__wbindgen_free(ret[0], ret[1] * 1, 1);
  return v1;
}

/**
 * @param {bigint} ptr
 * @param {bigint} other
 * @param {RustCallStatus} f_status_
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_signingidentity_uniffi_trait_eq_eq(
  ptr,
  other,
  f_status_
) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_signingidentity_uniffi_trait_eq_eq(
    ptr,
    other,
    f_status_.__wbg_ptr
  );
  return ret;
}

/**
 * @param {bigint} ptr
 * @param {bigint} other
 * @param {RustCallStatus} f_status_
 * @returns {number}
 */
export function ubrn_uniffi_mls_rs_uniffi_fn_method_signingidentity_uniffi_trait_eq_ne(
  ptr,
  other,
  f_status_
) {
  _assertClass(f_status_, RustCallStatus);
  const ret = wasm.ubrn_uniffi_mls_rs_uniffi_fn_method_signingidentity_uniffi_trait_eq_ne(
    ptr,
    other,
    f_status_.__wbg_ptr
  );
  return ret;
}

function __wbg_get_imports() {
  const import0 = {
    __proto__: null,
    __wbg___wbindgen_is_function_d633e708baf0d146: function (arg0) {
      const ret = typeof arg0 === 'function';
      return ret;
    },
    __wbg___wbindgen_is_object_4b3de556756ee8a8: function (arg0) {
      const val = arg0;
      const ret = typeof val === 'object' && val !== null;
      return ret;
    },
    __wbg___wbindgen_is_string_7debe47dc1e045c2: function (arg0) {
      const ret = typeof arg0 === 'string';
      return ret;
    },
    __wbg___wbindgen_is_undefined_c18285b9fc34cb7d: function (arg0) {
      const ret = arg0 === undefined;
      return ret;
    },
    __wbg___wbindgen_throw_39bc967c0e5a9b58: function (arg0, arg1) {
      throw new Error(getStringFromWasm0(arg0, arg1));
    },
    __wbg_call_00a38c8748ff4b23: function (arg0, arg1, arg2, arg3, arg4, arg5, arg6) {
      var v0 = getArrayU8FromWasm0(arg3, arg4).slice();
      wasm.__wbindgen_free(arg3, arg4 * 1, 1);
      var v1 = getArrayU8FromWasm0(arg5, arg6).slice();
      wasm.__wbindgen_free(arg5, arg6 * 1, 1);
      const ret = arg0.call(arg1, BigInt.asUintN(64, arg2), v0, v1);
      return ret;
    },
    __wbg_call_08426a7d24e7bf75: function (arg0, arg1, arg2, arg3, arg4) {
      var v0 = getArrayU8FromWasm0(arg3, arg4).slice();
      wasm.__wbindgen_free(arg3, arg4 * 1, 1);
      const ret = arg0.call(arg1, BigInt.asUintN(64, arg2), v0);
      return ret;
    },
    __wbg_call_08ad0d89caa7cb79: function () {
      return handleError(function (arg0, arg1, arg2) {
        const ret = arg0.call(arg1, arg2);
        return ret;
      }, arguments);
    },
    __wbg_call_27c5f593a7ad6659: function (arg0, arg1, arg2, arg3, arg4) {
      var v0 = getArrayU8FromWasm0(arg3, arg4).slice();
      wasm.__wbindgen_free(arg3, arg4 * 1, 1);
      const ret = arg0.call(arg1, BigInt.asUintN(64, arg2), v0);
      return ret;
    },
    __wbg_call_2d4830eebdba5384: function (arg0, arg1, arg2) {
      arg0.call(arg1, BigInt.asUintN(64, arg2));
    },
    __wbg_call_780dd8527fceb405: function (arg0, arg1, arg2, arg3, arg4) {
      var v0 = getArrayU8FromWasm0(arg3, arg4).slice();
      wasm.__wbindgen_free(arg3, arg4 * 1, 1);
      const ret = arg0.call(arg1, BigInt.asUintN(64, arg2), v0);
      return ret;
    },
    __wbg_call_e43532c3df59a470: function (
      arg0,
      arg1,
      arg2,
      arg3,
      arg4,
      arg5,
      arg6,
      arg7,
      arg8,
      arg9,
      arg10
    ) {
      var v0 = getArrayU8FromWasm0(arg3, arg4).slice();
      wasm.__wbindgen_free(arg3, arg4 * 1, 1);
      var v1 = getArrayU8FromWasm0(arg5, arg6).slice();
      wasm.__wbindgen_free(arg5, arg6 * 1, 1);
      var v2 = getArrayU8FromWasm0(arg7, arg8).slice();
      wasm.__wbindgen_free(arg7, arg8 * 1, 1);
      var v3 = getArrayU8FromWasm0(arg9, arg10).slice();
      wasm.__wbindgen_free(arg9, arg10 * 1, 1);
      const ret = arg0.call(arg1, BigInt.asUintN(64, arg2), v0, v1, v2, v3);
      return ret;
    },
    __wbg_call_e690f2b3ab10ab88: function (arg0, arg1, arg2, arg3, arg4, arg5) {
      var v0 = getArrayU8FromWasm0(arg3, arg4).slice();
      wasm.__wbindgen_free(arg3, arg4 * 1, 1);
      const ret = arg0.call(arg1, BigInt.asUintN(64, arg2), v0, BigInt.asUintN(64, arg5));
      return ret;
    },
    __wbg_code_0ed02ed287023c5b: function (arg0) {
      const ret = arg0.code;
      return ret;
    },
    __wbg_code_3ffcd5fb365214a7: function (arg0) {
      const ret = arg0.code;
      return ret;
    },
    __wbg_crypto_38df2bab126b63dc: function (arg0) {
      const ret = arg0.crypto;
      return ret;
    },
    __wbg_delete_c6310c8792a9835f: function (arg0) {
      const ret = arg0.delete;
      return ret;
    },
    __wbg_epoch_d84673ab93de16c8: function (arg0) {
      const ret = arg0.epoch;
      return ret;
    },
    __wbg_error_buf_795220397b643f50: function (arg0, arg1) {
      const ret = arg1.errorBuf;
      var ptr1 = isLikeNone(ret) ? 0 : passArray8ToWasm0(ret, wasm.__wbindgen_malloc);
      var len1 = WASM_VECTOR_LEN;
      getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
      getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    },
    __wbg_error_buf_b376b770999ec872: function (arg0, arg1) {
      const ret = arg1.errorBuf;
      var ptr1 = isLikeNone(ret) ? 0 : passArray8ToWasm0(ret, wasm.__wbindgen_malloc);
      var len1 = WASM_VECTOR_LEN;
      getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
      getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    },
    __wbg_getRandomValues_c44a50d8cfdaebeb: function () {
      return handleError(function (arg0, arg1) {
        arg0.getRandomValues(arg1);
      }, arguments);
    },
    __wbg_get_c7be003b387dbc8f: function (arg0) {
      const ret = arg0.get;
      return ret;
    },
    __wbg_insert_248ad772f5d50374: function (arg0) {
      const ret = arg0.insert;
      return ret;
    },
    __wbg_length_5855c1f289dfffc1: function (arg0) {
      const ret = arg0.length;
      return ret;
    },
    __wbg_maxEpochId_d9438a7b6169184f: function (arg0) {
      const ret = arg0.maxEpochId;
      return ret;
    },
    __wbg_msCrypto_bd5a034af96bcba6: function (arg0) {
      const ret = arg0.msCrypto;
      return ret;
    },
    __wbg_new_with_length_c8449d782396d344: function (arg0) {
      const ret = new Uint8Array(arg0 >>> 0);
      return ret;
    },
    __wbg_node_84ea875411254db1: function (arg0) {
      const ret = arg0.node;
      return ret;
    },
    __wbg_pointee_de27977e1d54a401: function (arg0, arg1) {
      const ret = arg1.pointee;
      var ptr1 = isLikeNone(ret) ? 0 : passArray8ToWasm0(ret, wasm.__wbindgen_malloc);
      var len1 = WASM_VECTOR_LEN;
      getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
      getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
    },
    __wbg_process_44c7a14e11e9f69e: function (arg0) {
      const ret = arg0.process;
      return ret;
    },
    __wbg_prototypesetcall_f034d444741426c3: function (arg0, arg1, arg2) {
      Uint8Array.prototype.set.call(getArrayU8FromWasm0(arg0, arg1), arg2);
    },
    __wbg_randomFillSync_6c25eac9869eb53c: function () {
      return handleError(function (arg0, arg1) {
        arg0.randomFillSync(arg1);
      }, arguments);
    },
    __wbg_require_b4edbdcf3e2a1ef0: function () {
      return handleError(function () {
        const ret = module.require;
        return ret;
      }, arguments);
    },
    __wbg_state_20c9a01f3300a4d7: function (arg0) {
      const ret = arg0.state;
      return ret;
    },
    __wbg_static_accessor_GLOBAL_THIS_14325d8cca34bb77: function () {
      const ret = typeof globalThis === 'undefined' ? null : globalThis;
      return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    },
    __wbg_static_accessor_GLOBAL_f3a1e69f9c5a7e8e: function () {
      const ret = typeof global === 'undefined' ? null : global;
      return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    },
    __wbg_static_accessor_SELF_50cdb5b517789aca: function () {
      const ret = typeof self === 'undefined' ? null : self;
      return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    },
    __wbg_static_accessor_WINDOW_d6c4126e4c244380: function () {
      const ret = typeof window === 'undefined' ? null : window;
      return isLikeNone(ret) ? 0 : addToExternrefTable0(ret);
    },
    __wbg_subarray_7ad5f01d4a9c1c4d: function (arg0, arg1, arg2) {
      const ret = arg0.subarray(arg1 >>> 0, arg2 >>> 0);
      return ret;
    },
    __wbg_uniffiFree_24f088e94f7390c0: function (arg0) {
      const ret = arg0.uniffiFree;
      return ret;
    },
    __wbg_versions_276b2795b1c6a219: function (arg0) {
      const ret = arg0.versions;
      return ret;
    },
    __wbg_write_9ec7e985217de34a: function (arg0) {
      const ret = arg0.write;
      return ret;
    },
    __wbindgen_cast_0000000000000001: function (arg0, arg1) {
      // Cast intrinsic for `Ref(Slice(U8)) -> NamedExternref("Uint8Array")`.
      const ret = getArrayU8FromWasm0(arg0, arg1);
      return ret;
    },
    __wbindgen_cast_0000000000000002: function (arg0, arg1) {
      // Cast intrinsic for `Ref(String) -> Externref`.
      const ret = getStringFromWasm0(arg0, arg1);
      return ret;
    },
    __wbindgen_init_externref_table: function () {
      const table = wasm.__wbindgen_externrefs;
      const offset = table.grow(4);
      table.set(0, undefined);
      table.set(offset + 0, undefined);
      table.set(offset + 1, null);
      table.set(offset + 2, true);
      table.set(offset + 3, false);
    },
  };
  return {
    __proto__: null,
    './index_bg.js': import0,
    './snippets/mls-rs-core-77e30828bc5a77d3/inline0.js': import1,
  };
}

const RustCallStatusFinalization =
  typeof FinalizationRegistry === 'undefined'
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_rustcallstatus_free(ptr >>> 0, 1));

function addToExternrefTable0(obj) {
  const idx = wasm.__externref_table_alloc();
  wasm.__wbindgen_externrefs.set(idx, obj);
  return idx;
}

function _assertClass(instance, klass) {
  if (!(instance instanceof klass)) {
    throw new Error(`expected instance of ${klass.name}`);
  }
}

function getArrayU8FromWasm0(ptr, len) {
  ptr = ptr >>> 0;
  return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

let cachedDataViewMemory0 = null;
function getDataViewMemory0() {
  if (
    cachedDataViewMemory0 === null ||
    cachedDataViewMemory0.buffer.detached === true ||
    (cachedDataViewMemory0.buffer.detached === undefined &&
      cachedDataViewMemory0.buffer !== wasm.memory.buffer)
  ) {
    cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
  }
  return cachedDataViewMemory0;
}

function getStringFromWasm0(ptr, len) {
  ptr = ptr >>> 0;
  return decodeText(ptr, len);
}

let cachedUint8ArrayMemory0 = null;
function getUint8ArrayMemory0() {
  if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
    cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
  }
  return cachedUint8ArrayMemory0;
}

function handleError(f, args) {
  try {
    return f.apply(this, args);
  } catch (e) {
    const idx = addToExternrefTable0(e);
    wasm.__wbindgen_exn_store(idx);
  }
}

function isLikeNone(x) {
  return x === undefined || x === null;
}

function passArray8ToWasm0(arg, malloc) {
  const ptr = malloc(arg.length * 1, 1) >>> 0;
  getUint8ArrayMemory0().set(arg, ptr / 1);
  WASM_VECTOR_LEN = arg.length;
  return ptr;
}

let cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
cachedTextDecoder.decode();
const MAX_SAFARI_DECODE_BYTES = 2146435072;
let numBytesDecoded = 0;
function decodeText(ptr, len) {
  numBytesDecoded += len;
  if (numBytesDecoded >= MAX_SAFARI_DECODE_BYTES) {
    cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });
    cachedTextDecoder.decode();
    numBytesDecoded = len;
  }
  return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let WASM_VECTOR_LEN = 0;

let wasmModule, wasm;
function __wbg_finalize_init(instance, module) {
  wasm = instance.exports;
  wasmModule = module;
  cachedDataViewMemory0 = null;
  cachedUint8ArrayMemory0 = null;
  wasm.__wbindgen_start();
  return wasm;
}

async function __wbg_load(module, imports) {
  if (typeof Response === 'function' && module instanceof Response) {
    if (typeof WebAssembly.instantiateStreaming === 'function') {
      try {
        return await WebAssembly.instantiateStreaming(module, imports);
      } catch (e) {
        const validResponse = module.ok && expectedResponseType(module.type);

        if (validResponse && module.headers.get('Content-Type') !== 'application/wasm') {
          console.warn(
            '`WebAssembly.instantiateStreaming` failed because your server does not serve Wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n',
            e
          );
        } else {
          throw e;
        }
      }
    }

    const bytes = await module.arrayBuffer();
    return await WebAssembly.instantiate(bytes, imports);
  } else {
    const instance = await WebAssembly.instantiate(module, imports);

    if (instance instanceof WebAssembly.Instance) {
      return { instance, module };
    } else {
      return instance;
    }
  }

  function expectedResponseType(type) {
    switch (type) {
      case 'basic':
      case 'cors':
      case 'default':
        return true;
    }
    return false;
  }
}

function initSync(module) {
  if (wasm !== undefined) return wasm;

  if (module !== undefined) {
    if (Object.getPrototypeOf(module) === Object.prototype) {
      ({ module } = module);
    } else {
      console.warn('using deprecated parameters for `initSync()`; pass a single object instead');
    }
  }

  const imports = __wbg_get_imports();
  if (!(module instanceof WebAssembly.Module)) {
    module = new WebAssembly.Module(module);
  }
  const instance = new WebAssembly.Instance(module, imports);
  return __wbg_finalize_init(instance, module);
}

async function __wbg_init(module_or_path) {
  if (wasm !== undefined) return wasm;

  if (module_or_path !== undefined) {
    if (Object.getPrototypeOf(module_or_path) === Object.prototype) {
      ({ module_or_path } = module_or_path);
    } else {
      console.warn(
        'using deprecated parameters for the initialization function; pass a single object instead'
      );
    }
  }

  const imports = __wbg_get_imports();

  if (
    typeof module_or_path === 'string' ||
    (typeof Request === 'function' && module_or_path instanceof Request) ||
    (typeof URL === 'function' && module_or_path instanceof URL)
  ) {
    module_or_path = fetch(module_or_path);
  }

  const { instance, module } = await __wbg_load(await module_or_path, imports);

  return __wbg_finalize_init(instance, module);
}

export { initSync, __wbg_init as default };
